import SolutionHeroI18n from "@/components/landing/shared/SolutionHeroI18n";
import { Headphones, MessageCircle, Clock, Shield, ThumbsUp, BarChart3 } from "lucide-react";
import heroImage from "@/assets/hero-person-kundenservice-male.png";

const KundenserviceHero = () => (
  <SolutionHeroI18n
    translationPrefix="kundenserviceSolution"
    heroImage={heroImage}
    floatingIcons={[
      { icon: Headphones, position: "top-[0%] left-[10%]", delay: "0s", duration: "3s", color: "orange" },
      { icon: MessageCircle, position: "top-[0%] right-[10%]", delay: "0.5s", duration: "3.5s", color: "mint" },
      { icon: Clock, position: "top-[30%] -left-[6%]", delay: "1s", duration: "4s", color: "primary" },
      { icon: Shield, position: "top-[60%] -left-[4%]", delay: "1.5s", duration: "3.2s", color: "mint" },
      { icon: ThumbsUp, position: "bottom-[3%] left-[15%]", delay: "0.7s", duration: "3.8s", color: "orange" },
      { icon: BarChart3, position: "top-[25%] -right-[6%]", delay: "2s", duration: "3.6s", color: "primary" },
    ]}
    kpis={[
      { icon: MessageCircle, labelKey: "kpiTickets", valueKey: "kpiTicketsValue", color: "text-chathero-mint" },
      { icon: Clock, labelKey: "kpiResponse", valueKey: "kpiResponseValue", color: "text-chathero-orange" },
      { icon: ThumbsUp, labelKey: "kpiSatisfaction", valueKey: "kpiSatisfactionValue", color: "text-primary" },
    ]}
  />
);

export default KundenserviceHero;
